var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row align-items-center mt-2"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"page-title-box"},[_c('h4',{staticClass:"font-size-18"},[_vm._v(_vm._s(_vm.title))]),_c('ol',{staticClass:"breadcrumb mb-0 mt-n2"},[_c('li',{staticClass:"breadcrumb-item active"},[_vm._v(_vm._s(_vm.description))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }